import { render, staticRenderFns } from "./DotNet.vue?vue&type=template&id=391277a3&scoped=true"
import script from "./DotNet.vue?vue&type=script&lang=js"
export * from "./DotNet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391277a3",
  null
  
)

export default component.exports